/* Miles & Made seat covers: design data.
   Edit here to change colourways, materials or finishes. Prices, names, images
   and descriptions come from the Shopify products (Admin > Products).
   Colour codes are the supplier colour card numbers with "MM" in place of "#" (e.g. #114-3968 -> MM114-3968).
   We show codes, not colour names, everywhere on the site. Each signature colourway also has a short name (label),
   shown before its codes. Labels must not reuse standard colour words.
   stitch "match" = same colour as the main body. */
window.MS_DATA = {
  rowsDef: [
    { id: "first", label: "First row", note: "Driver and passenger seats, headrests, armrests" },
    { id: "second", label: "Second row", note: "Rear bench or captain's chairs, headrests" },
    { id: "third", label: "Third row", note: "Third-row seats, headrests" },
    { id: "fourth", label: "Fourth row", note: "Fourth-row seats, headrests" },
    { id: "fifth", label: "Fifth row", note: "Fifth-row seats, headrests" }
  ],
  materials: [
    { code: "MM1-3958", name: "MM1-3958", hex: "#000000" },
    { code: "MM16-3958", name: "MM16-3958", hex: "#FFFFFF" },
    { code: "MM14-3958", name: "MM14-3958", hex: "#4B4D4A" },
    { code: "MM9-3958", name: "MM9-3958", hex: "#858680" },
    { code: "MM12-3958", name: "MM12-3958", hex: "#AFA279" },
    { code: "MM8-3958", name: "MM8-3958", hex: "#995C3B" },
    { code: "MM7-3958", name: "MM7-3958", hex: "#4B3C37" },
    { code: "MM3-3958", name: "MM3-3958", hex: "#6B2B28" },
    { code: "MM2-3958", name: "MM2-3958", hex: "#C52E34" },
    { code: "MM006-3998", name: "MM006-3998", hex: "#F4611D" },
    { code: "MM15-3958", name: "MM15-3958", hex: "#253F74" },
    { code: "MM114-3968", name: "MM114-3968", hex: "#2C4535" }
  ],
  /* The first colourway of each design matches the supplier's approved photo (the product image). */
  designs: {
    "the-tourer": { tag: "Vertical channels", pattern: "channel", finishes: ["Perforated centres", "Smooth"],
      colours: [
        { label: "Henley", name: "MM15-3958 & MM16-3958", body: "MM15-3958", insert: "MM16-3958", stitch: "match" },
        { label: "Belgravia", name: "MM1-3958 & MM16-3958", body: "MM1-3958", insert: "MM16-3958", stitch: "MM16-3958" },
        { label: "Mayfair", name: "MM1-3958", body: "MM1-3958", insert: "MM1-3958", stitch: "match" },
        { label: "Cotswold", name: "MM8-3958 & MM1-3958", body: "MM8-3958", insert: "MM1-3958", stitch: "MM8-3958" }
      ] },
    "the-quilted": { tag: "Diamond-quilted", pattern: "diamond", finishes: ["Perforated centres", "Smooth"],
      colours: [
        { label: "Knightsbridge", name: "MM1-3958", body: "MM1-3958", insert: "MM1-3958", stitch: "match" },
        { label: "Chiltern", name: "MM8-3958", body: "MM8-3958", insert: "MM8-3958", stitch: "match" },
        { label: "Brooklands", name: "MM14-3958", body: "MM14-3958", insert: "MM14-3958", stitch: "MM2-3958" },
        { label: "Marlow", name: "MM3-3958", body: "MM3-3958", insert: "MM3-3958", stitch: "match" }
      ] },
    "the-heritage": { tag: "Square quilt", pattern: "square", finishes: ["Perforated centres", "Smooth"],
      colours: [
        { label: "Windsor", name: "MM12-3958 & MM7-3958", body: "MM12-3958", insert: "MM7-3958", stitch: "MM12-3958" },
        { label: "Ascot", name: "MM1-3958 & MM8-3958", body: "MM1-3958", insert: "MM8-3958", stitch: "MM8-3958" },
        { label: "Pennine", name: "MM9-3958 & MM1-3958", body: "MM9-3958", insert: "MM1-3958", stitch: "MM9-3958" },
        { label: "Hampstead", name: "MM16-3958 & MM7-3958", body: "MM16-3958", insert: "MM7-3958", stitch: "MM16-3958" }
      ] },
    "the-alpine": { tag: "Hexagon quilt", pattern: "hex", finishes: ["Perforated centres", "Smooth"],
      colours: [
        { label: "Stelvio", name: "MM1-3958 with MM2-3958 stitching", body: "MM1-3958", insert: "MM1-3958", stitch: "MM2-3958" },
        { label: "Grimsel", name: "MM114-3968 & MM12-3958", body: "MM114-3968", insert: "MM12-3958", stitch: "MM12-3958" },
        { label: "Furka", name: "MM1-3958 & MM9-3958", body: "MM1-3958", insert: "MM9-3958", stitch: "MM9-3958" },
        { label: "Bernina", name: "MM14-3958 & MM006-3998", body: "MM14-3958", insert: "MM006-3998", stitch: "MM006-3998" },
        { label: "Albula", name: "MM3-3958 & MM1-3958", body: "MM3-3958", insert: "MM1-3958", stitch: "MM3-3958" }
      ] }
  }
};
